import clsx from "clsx";

export const bgImg = clsx(
    "absolute rounded-full h-[380px] object-cover w-full",
);
export const parentContainer = clsx(
    "flex flex-col lg:flex-row w-full items-center lg:justify-around mt-20"
);
export const solutionContainer = clsx(
    "flex flex-col items-center max-w-[320px] relative",
);
export const title = clsx("text-2xl uppercase max-w-[220px] h-[100px] flex items-center text-center mb-4 ");
export const lottie = clsx(
    "w-full justify-center flex flex-col rounded-full h-[400px]",
);